import { Chip } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FileCopySharp } from '@material-ui/icons';
import UploadCsvButton from './UploadCsvButton';

const useStyles = makeStyles({
  textfield: {
    width: ({ width }) => width || '321px',
    height: ({ height }) => height || '44px',
    padding: '12px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnUploadStyle: {
    height: '24px',
    marginLeft: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: '12px',
    color: '#FFFFFF',
    background: 'rgba(98, 47, 238, 1)',
    borderRadius: '4px',
    padding: '0 10px',
    cursor: 'pointer',
  },
  chip: {
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 0,
    background: 'rgba(242, 244, 247, 1)',
    overflow: 'hidden', // Prevent overflow
    whiteSpace: 'nowrap', // Prevent text wrapping
    textOverflow: 'ellipsis', // Show ellipsis for overflow
  },
  chipLabel: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '200px', // Set a max width to control overflow
  },
});

const CsvUploadField = ({ name, value, handleChange, handleDelete, fileName, width, height }) => {
  const classes = useStyles({ width, height, value });
  return (
    <div className={classes.textfield}>
      <Chip
        className={classes.chip}
        onDelete={handleDelete}
        deleteIcon={<span>&times;</span>}
        label={<div className={classes.chipLabel}>{fileName || <FileCopySharp />}</div>}
      />
      <UploadCsvButton
        name={name}
        disableElevation
        handleCsvUpload={handleChange}
        className={classes.btnUploadStyle}
        styles={{ height: '30px', border: '1px solid rgba(228, 231, 236, 1)', background: 'white' }}
      />
    </div>
  );
};

export default CsvUploadField;
